define(['exports', 'react', 'lodash', '../../assets/Logo-vertical.svg', './HeaderBar', './SessionDetails', './Sections', './CandidateInfoView', './SocialProfiles', './PetProjects'], function (exports, _react, _lodash, _LogoVertical, _HeaderBar, _SessionDetails, _Sections, _CandidateInfoView, _SocialProfiles, _PetProjects) {
	'use strict';

	Object.defineProperty(exports, "__esModule", {
		value: true
	});

	var _react2 = _interopRequireDefault(_react);

	var _lodash2 = _interopRequireDefault(_lodash);

	var _LogoVertical2 = _interopRequireDefault(_LogoVertical);

	var _HeaderBar2 = _interopRequireDefault(_HeaderBar);

	var _SessionDetails2 = _interopRequireDefault(_SessionDetails);

	var _Sections2 = _interopRequireDefault(_Sections);

	var _CandidateInfoView2 = _interopRequireDefault(_CandidateInfoView);

	var _SocialProfiles2 = _interopRequireDefault(_SocialProfiles);

	var _PetProjects2 = _interopRequireDefault(_PetProjects);

	function _interopRequireDefault(obj) {
		return obj && obj.__esModule ? obj : {
			default: obj
		};
	}

	function _classCallCheck(instance, Constructor) {
		if (!(instance instanceof Constructor)) {
			throw new TypeError("Cannot call a class as a function");
		}
	}

	var _createClass = function () {
		function defineProperties(target, props) {
			for (var i = 0; i < props.length; i++) {
				var descriptor = props[i];
				descriptor.enumerable = descriptor.enumerable || false;
				descriptor.configurable = true;
				if ("value" in descriptor) descriptor.writable = true;
				Object.defineProperty(target, descriptor.key, descriptor);
			}
		}

		return function (Constructor, protoProps, staticProps) {
			if (protoProps) defineProperties(Constructor.prototype, protoProps);
			if (staticProps) defineProperties(Constructor, staticProps);
			return Constructor;
		};
	}();

	function _possibleConstructorReturn(self, call) {
		if (!self) {
			throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
		}

		return call && (typeof call === "object" || typeof call === "function") ? call : self;
	}

	function _inherits(subClass, superClass) {
		if (typeof superClass !== "function" && superClass !== null) {
			throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
		}

		subClass.prototype = Object.create(superClass && superClass.prototype, {
			constructor: {
				value: subClass,
				enumerable: false,
				writable: true,
				configurable: true
			}
		});
		if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
	}

	var CandidateReportsView = function (_Component) {
		_inherits(CandidateReportsView, _Component);

		function CandidateReportsView(props) {
			_classCallCheck(this, CandidateReportsView);

			var _this = _possibleConstructorReturn(this, (CandidateReportsView.__proto__ || Object.getPrototypeOf(CandidateReportsView)).call(this, props));

			_this.state = {
				caratSummary: {
					total: 361,
					skills: [{
						name: "java",
						carat: 102,
						levels: [{
							name: "Level 1",
							carat: 94
						}, {
							name: "Leve1 2",
							carat: 8
						}]
					}, {
						name: "C#",
						carat: 52,
						levels: [{
							name: "Level 1",
							carat: 30
						}, {
							name: "Leve1 2",
							carat: 22
						}]
					}]
				}
			};
			return _this;
		}

		_createClass(CandidateReportsView, [{
			key: 'renderReports',
			value: function renderReports() {
				var _this2 = this;

				return this.props.reports.report.reports.map(function (report) {
					return _this2.renderCandidatesReportsView(report);
				});
			}
		}, {
			key: 'renderCandidateDetailedReportsView',
			value: function renderCandidateDetailedReportsView(report, criteriaScore, candidateProfile) {

				var shouldRenderSocialProfiles = candidateProfile && !_lodash2.default.isEmpty(_lodash2.default.compact(_lodash2.default.values(candidateProfile.socialProfiles)));
				var shouldRenderPetProjects = candidateProfile && !_lodash2.default.isEmpty(candidateProfile.petProjects);

				return _react2.default.createElement(
					'div',
					{ className: 'clearfix mb2' },
					_react2.default.createElement(
						'div',
						{ className: 'mx4' },
						_react2.default.createElement(_CandidateInfoView2.default, {
							profile: report.profile,
							caratSummary: this.state.caratSummary,
							skillGroups: candidateProfile && candidateProfile.skillSummary ? candidateProfile.skillSummary.skillGroups : [],
							criteriaScore: report.criteriaCaratScore || criteriaScore })
					),
					this.renderReports(),
					_react2.default.createElement(
						'div',
						{ className: 'mx4' },
						shouldRenderSocialProfiles && _react2.default.createElement(_SocialProfiles2.default, { socialProfiles: candidateProfile.socialProfiles }),
						shouldRenderPetProjects && _react2.default.createElement(_PetProjects2.default, { petProjects: candidateProfile.petProjects })
					)
				);
			}
		}, {
			key: 'renderCandidatesReportsView',
			value: function renderCandidatesReportsView(report) {

				return _react2.default.createElement(
					'div',
					{ className: 'clearfix mx4 mt2' },
					_react2.default.createElement(_HeaderBar2.default, {
						isDetailedReportsView: this.props.isDetailedReportsView,
						candidateName: report.firstName + ' ' + report.lastName,
						candidate: report.candidate || {},
						assessment: report.report.assessment,
						categoryName: report.categoryName }),
					_react2.default.createElement(
						'div',
						{ level: 1, className: 'card clearfix mx4 mt2 px4 white-background' },
						_react2.default.createElement(_SessionDetails2.default, {
							carats: report.caratsEarned,
							maxCarats: report.maxCarats,
							startedAt: report.report.startedAt,
							completedAt: report.report.completedAt,
							sessionName: report.sessionName,
							assessment: report.report.assessment })
					),
					_react2.default.createElement(_Sections2.default, { sections: report.report.sections })
				);
			}
		}, {
			key: 'render',
			value: function render() {
				var _props = this.props,
				    report = _props.reports.report,
				    _props$criteriaScore = _props.criteriaScore,
				    criteriaScore = _props$criteriaScore === undefined ? 0 : _props$criteriaScore,
				    candidateProfile = _props.candidateProfile,
				    isDetailedReportsView = _props.isDetailedReportsView;


				return _react2.default.createElement(
					'div',
					null,
					_react2.default.createElement(
						'div',
						{ className: 'my2 center' },
						_react2.default.createElement(_LogoVertical2.default, null)
					),
					isDetailedReportsView ? this.renderCandidateDetailedReportsView(report, criteriaScore, candidateProfile) : this.renderCandidatesReportsView(report)
				);
			}
		}]);

		return CandidateReportsView;
	}(_react.Component);

	exports.default = CandidateReportsView;
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/dk-ui-lib/lib/candidate-reports/index.js
// module id = 1180
// module chunks = 0